export const getFormattedVariableMarkdownContent = (
   markdown: string
): string => {
   const variableRegex = /\{\{.*?\s*.*?\}\}/g
   return markdown
      .replace(/\n/g, '  \n')
      .replace(variableRegex, match => `{{\`${match.slice(2, -2)}\`}}`)
}

export const getFormattedLineBreakMarkdownContent = (
   markdown: string
): string => {
   const variableRegex = /\{\{.*?\s*.*?\}\}/g
   return markdown
      .replace(/\n/g, '\n\u200B')
      .replace(variableRegex, match => `{{\`${match.slice(2, -2)}\`}}`)
}
